<lib-dialog>
  @if (esPerfil30()) {
    <!-- Perfil 3.0: identidad de solo lectura arriba, lo editable debajo y el estado en el pie. -->
    <div class="perfil30-modal">
      <header class="perfil30-modal__cabecera">
        <span class="perfil30-modal__icono"><lib-icon name="User" [size]="16" /></span>
        <div class="perfil30-modal__titulos">
          <h2 class="perfil30-modal__titulo">{{ 'PROFILE.DIALOG.TITLE' | translate }}</h2>
          <p class="perfil30-modal__subtitulo">{{ 'PROFILE.DIALOG.SUBTITLE' | translate }}</p>
        </div>
        <button
          type="button"
          class="perfil30-modal__cerrar"
          (click)="cerrar()"
          [attr.aria-label]="'ACTIONS.CLOSE' | translate"
        >
          <lib-icon name="X" [size]="14" />
        </button>
      </header>

      @if (loading()) {
        <div class="perfil30-modal__cuerpo perfil30-modal__esqueleto" aria-busy="true">
          <div class="perfil30-modal__esqueleto-ficha">
            <span class="perfil30-modal__esqueleto-avatar"></span>
            <span class="perfil30-modal__esqueleto-lineas"><span></span><span></span></span>
          </div>
          <div class="perfil30-modal__esqueleto-campos">
            <span></span><span></span><span class="perfil30-modal__ancho"></span>
          </div>
        </div>
      } @else if (cargaFallida()) {
        <!-- El error que impide seguir se queda en el cuerpo y ofrece reintentar. -->
        <div class="perfil30-modal__cuerpo perfil30-modal__error">
          <span class="perfil30-modal__error-icono"><lib-icon name="CloudOff" [size]="19" /></span>
          <p class="perfil30-modal__error-titulo">{{ 'PROFILE.ERROR.LOAD' | translate }}</p>
          <p class="perfil30-modal__error-ayuda">
            {{ 'PROFILE.DIALOG.LOAD_ERROR_HINT' | translate }}
          </p>
          <button type="button" class="perfil30-modal__reintentar" (click)="cargar()">
            <lib-icon name="RotateCw" [size]="14" />{{ 'ACTIONS.RETRY' | translate }}
          </button>
        </div>
      } @else {
        <form class="perfil30-modal__cuerpo" [formGroup]="form" (ngSubmit)="guardar()">
          <div class="perfil30-modal__ficha">
            <span class="perfil30-modal__avatar">{{ iniciales() }}</span>
            <div class="perfil30-modal__identidad">
              <p class="perfil30-modal__nombre">{{ nombreCompleto() }}</p>
              <p class="perfil30-modal__datos">
                <span><lib-icon name="AtSign" [size]="12" />{{ form.getRawValue().username }}</span>
                <span>
                  <lib-icon name="IdCard" [size]="12" />{{ tipoDocumentoCodigo() }}
                  <span class="perfil30-modal__numero">{{
                    form.getRawValue().numeroDocumento
                  }}</span>
                </span>
              </p>
            </div>
            <span
              class="perfil30-modal__lectura"
              [title]="'PROFILE.DIALOG.READ_ONLY_TOOLTIP' | translate"
            >
              <lib-icon name="Lock" [size]="10" />{{ 'PROFILE.DIALOG.READ_ONLY' | translate }}
            </span>
          </div>

          <div class="perfil30-modal__seccion">
            <lib-icon name="SquarePen" [size]="14" />
            <h3>{{ 'PROFILE.DIALOG.EDITABLE' | translate }}</h3>
            <span class="perfil30-modal__filete"></span>
          </div>

          <div class="perfil30-modal__campos">
            <div>
              <lib-field-label [label]="'PROFILE.FIELD.FIRST_NAME' | translate" [required]="true" />
              <lib-input
                id="pmNombres30"
                formControlName="nombres"
                [placeholder]="'PROFILE.DIALOG.PLACEHOLDER.FIRST_NAME' | translate"
                [errorMsg]="getError('nombres')"
                [externalLabel]="true"
              ></lib-input>
            </div>
            <div>
              <lib-field-label [label]="'PROFILE.FIELD.LAST_NAME' | translate" [required]="true" />
              <lib-input
                id="pmApellidos30"
                formControlName="apellidos"
                [placeholder]="'PROFILE.DIALOG.PLACEHOLDER.LAST_NAME' | translate"
                [errorMsg]="getError('apellidos')"
                [externalLabel]="true"
              ></lib-input>
            </div>
            <div class="perfil30-modal__ancho">
              <lib-field-label [label]="'PROFILE.FIELD.EMAIL' | translate" [required]="true" />
              <lib-input
                id="pmEmail30"
                type="email"
                formControlName="email"
                prefixIcon="Mail"
                [placeholder]="'PROFILE.DIALOG.PLACEHOLDER.EMAIL' | translate"
                [hint]="'PROFILE.DIALOG.EMAIL_HINT' | translate"
                [errorMsg]="getError('email')"
                [externalLabel]="true"
              ></lib-input>
            </div>
          </div>
        </form>
      }

      <footer class="perfil30-modal__pie">
        <span class="perfil30-modal__estado" [attr.data-tono]="estadoPie().tono">
          <lib-icon [name]="estadoPie().icono" [size]="13" />{{ estadoPie().clave | translate }}
        </span>
        <button type="button" class="perfil30-modal__cancelar" (click)="cerrar()">
          {{ 'ACTIONS.CANCEL' | translate }}
        </button>
        <button
          type="button"
          class="perfil30-modal__guardar"
          [disabled]="!puedeGuardar()"
          (click)="guardar()"
        >
          <lib-icon name="Check" [size]="14" />{{ 'ACTIONS.SAVE' | translate }}
        </button>
      </footer>
    </div>
  } @else {
    <div class="perfil-dialog-content">
      <div class="dialog-header">
        <h3 class="dialog-title">{{ 'PROFILE.DIALOG.TITLE' | translate }}</h3>
        <button
          type="button"
          class="close-btn"
          (click)="cerrar()"
          [attr.aria-label]="'ACTIONS.CLOSE' | translate"
        >
          ✕
        </button>
      </div>

      <div class="perfil-dialog-body">
        @if (loading()) {
          <p class="perfil-loading">{{ 'PROFILE.STATUS.LOADING' | translate }}</p>
        } @else {
          @if (errorMsg()) {
            <div class="perfil-alert perfil-alert--error">{{ errorMsg() }}</div>
          }

          <form [formGroup]="form" (ngSubmit)="guardar()">
            <lib-grid-form preset="2cols" gap="1.1rem" wrapperClass="perfil-modal-grid">
              <lib-grid-form-item>
                <lib-field-label
                  [label]="'PROFILE.FIELD.USERNAME' | translate"
                  [tooltip]="'PROFILE.FIELD.USERNAME_TOOLTIP' | translate"
                />
                <lib-input
                  id="pmUsername"
                  formControlName="username"
                  [disabled]="true"
                  [externalLabel]="true"
                ></lib-input>
              </lib-grid-form-item>

              <lib-grid-form-item>
                <lib-field-label [label]="'PROFILE.FIELD.DOCUMENT_TYPE' | translate" />
                <lib-input
                  id="pmTipoDoc"
                  formControlName="tipoDocumento"
                  [disabled]="true"
                  [externalLabel]="true"
                ></lib-input>
              </lib-grid-form-item>

              <lib-grid-form-item>
                <lib-field-label [label]="'PROFILE.FIELD.DOCUMENT_NUMBER' | translate" />
                <lib-input
                  id="pmNumDoc"
                  formControlName="numeroDocumento"
                  [disabled]="true"
                  [externalLabel]="true"
                ></lib-input>
              </lib-grid-form-item>

              <lib-grid-form-item>
                <lib-field-label
                  [label]="'PROFILE.FIELD.FIRST_NAME' | translate"
                  [required]="true"
                />
                <lib-input
                  id="pmNombres"
                  formControlName="nombres"
                  [errorMsg]="getError('nombres')"
                  [externalLabel]="true"
                ></lib-input>
              </lib-grid-form-item>

              <lib-grid-form-item>
                <lib-field-label
                  [label]="'PROFILE.FIELD.LAST_NAME' | translate"
                  [required]="true"
                />
                <lib-input
                  id="pmApellidos"
                  formControlName="apellidos"
                  [errorMsg]="getError('apellidos')"
                  [externalLabel]="true"
                ></lib-input>
              </lib-grid-form-item>

              <lib-grid-form-item>
                <lib-field-label [label]="'PROFILE.FIELD.EMAIL' | translate" [required]="true" />
                <lib-input
                  id="pmEmail"
                  type="email"
                  formControlName="email"
                  [errorMsg]="getError('email')"
                  [externalLabel]="true"
                ></lib-input>
              </lib-grid-form-item>
            </lib-grid-form>

            <footer class="perfil-dialog-footer">
              <button type="button" class="perfil-btn perfil-btn--ghost" (click)="cerrar()">
                {{ 'ACTIONS.CANCEL' | translate }}
              </button>
              <button type="submit" class="perfil-btn perfil-btn--primary" [disabled]="saving()">
                {{ saving() ? ('ACTIONS.SAVE_CHANGES' | translate) : ('ACTIONS.SAVE' | translate) }}
              </button>
            </footer>
          </form>
        }
      </div>
    </div>
  }
</lib-dialog>
